const setLocalState = (_useStateFn, key, defaultValue)=>
{
  const loadedValue = localStorage.getItem(key);
  let stateVal, setStateVal;
  if(loadedValue && loadedValue != 'undefined')
  {
    [stateVal, setStateVal] =_useStateFn(JSON.parse(loadedValue));
  }
  else
  {
    [stateVal, setStateVal] =_useStateFn(defaultValue);
  }
  return([stateVal, (newVal=>{
    if(typeof(newVal)=='function')
    {
      setStateVal(currentVal=>{
        let updatedVal = newVal(currentVal);
        localStorage.setItem(key, JSON.stringify(updatedVal));
        return(updatedVal);
      });
    }
    else
    {
      localStorage.setItem(key, JSON.stringify(newVal));
      setStateVal(newVal);
    }
  })])
}

export default setLocalState;